import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div style={{ width: '100vw', textAlign: "center", marginTop: "50px" }}>
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>Sorry, the page you are looking for does not exist.</p>
      <Link to="/">Go back Home</Link>
    </div>
  );
}
